import {
  gtmScreenName,
  trackEventBuyer,
  trackEventBuyerWithExtraParams,
  trackEventSeller,
  trackEvent,
} from "GTMs/libs";
import {
  addQueryParamsToLinkPostView,
  EnumPostRef,
  linkToPostView,
} from "helpers/links-builders/post";
import { ENUMSELLERFLOWTYPES } from "../../types";

export const gtmPostViewBackBtn = () => {
  trackEventBuyer("InitBrowse", `Back`);
};

export const gtmPostViewShareBtn = () => {
  trackEventBuyer("Share", `ShareBtn`);
};

export const gtmPostViewGalleryShareBtn = () => {
  trackEventBuyer("Share", `NativeBtn_PostGalleryScreen`, true);
};
export const gtmPostViewGalleryCallBtn = () => {
  trackEventBuyer("Call", `BBCallBtn_PostGalleryScreen`, true);
};
export const gtmPostViewGalleryChatBtn = () => {
  trackEventBuyer("InitChatSendMessage", `BBChatBtn_PostGalleryScreen`, true);
};
export const gtmPostViewGalleryFavBtn = (eventAction) => {
  trackEventBuyer(eventAction, `FavBtn_PostGalleryScreen`, true);
  if (eventAction === "Favourite") {
    trackEventBuyer("ChatSendMessage", `API_500_Fav_PostGalleryScreen`, true);
  }
};
export const gtmPostViewGalleryExpandBtn = () => {
  trackEventBuyer("ExpandViewOn", `ExpandViewOnBtn_PostGalleryScreen`, true);
};
export const gtmPostViewGalleryUnExpandBtn = () => {
  trackEventBuyer("SwipeViewOn", `SwipeViewOnBtn_PostGalleryScreen`, true);
};
export const gtmPostViewGalleryMenuFavBtn = (eventAction) => {
  trackEventBuyer(eventAction, `FavBtn_Menu_PostGalleryScreen`, true);
};
export const gtmPostViewGalleryMenuShareBtn = () => {
  trackEventBuyer("share", `NativeBtn_Menu_PostGalleryScreen`, true);
};
export const gtmPostViewGalleryMenuSaveImagesBtn = () => {
  trackEventBuyer("InitSaveImage", `SaveImageBtn_Menu_PostGalleryScreen`, true);
};
export const gtmPostViewGalleryMenuReportBtn = (eventAction) => {
  trackEventBuyer(eventAction, `ReportPostBtn_Menu_PostGalleryScreen`, true);
};
export const gtmPostViewShareTopBarBtn = () => {
  trackEventBuyer("Share", `ShareBtn_TopBar`);
};

export const gtmPostViewSubCategory = () => {
  trackEventBuyer("InitBrowse", `SubCategoryLink`);
};

export const gtmShowMoreInfo = () => {
  trackEventBuyer("SeeMore", `SeeMoreCPsBtn`);
};

export const gtmAskForPriceBtn = () => {
  trackEventBuyer("InitAskForPrice", `AskForPriceBtn`, true);
};

export const gtmAskForImagesBtn = () => {
  trackEventBuyer("InitAskForImage", `AskForImageBtn`);
};
export const gtmAskForLocationBtn = () => {
  trackEventBuyer("InitAskForMap", `AskForMapBtn`);
};
export const gtmAskForPriceTopBarBtn = () => {
  trackEventBuyer("InitAskForPrice", `AskForPriceBtn_TopBar`);
};

export const gtmPostViewCallBtn = (label = "CallBtn") => {
  trackEventBuyer("Call", `${label}`);
};

export const gtmChatBtn = (label = "ChatBtn") => {
  trackEventBuyer("InitChatSendMessage", `${label}`);
};

export const gtmFavoriteBtn = (eventAction) => {
  trackEventBuyerWithExtraParams(eventAction, `FavBtn`);
};

export const gtmPostOwnerCard = () => {
  trackEventBuyer("Mid", `OwnerSection`);
};

export const gtmAddSimilarPostBtn = () => {
  trackEventSeller("InitAddPost", `AddSimilarPostBtn`);
};

export const gtmBoostAdBtn = () => {
  trackEventSeller(
    "InitBoostAd",
    `BoostAdBtn`,
    false,
    false,
    null,
    ENUMSELLERFLOWTYPES.Sellers
  );
};

export const gtmPostViewPagination = (type: "Previous" | "Next" = null) => {
  type && trackEventBuyer("InitPostView", `${type}Post`);
  return;
};

export const gtmSimilarAdItem = (e, url) => {
  const extra = {
    eventCallback: function () {
      window.location = url;
    },
    eventTimeout: 500,
  };
  trackEventBuyer("InitPostView", `SimilarPostCell`, false, false, extra);
};

export const gtmSimilarAdShowMoreBtn = () => {
  trackEventBuyer("InitBrowse", `MoreBtn_SimilarAds`);
};

export const gtmPostGalleryImage = () => {
  trackEventBuyer("PostGallery", `Image`);
};

export const gtmAskSeller = (key) => {
  trackEventBuyer("AskSeller", key);
};

export const gtmAskSellerSuccess = (key) => {
  trackEventBuyer("InitChatSendMessage", key);
};

export const gtmPostViewFavoriteBtn = (eventAction, extraData) => {
  trackEventBuyerWithExtraParams(eventAction, `FavBtn`, extraData);
};

export const gtmApplyForJob = () => {
  trackEventBuyer("InitApply", `ApplyBtn`);
};

export const gtmRecommendedAdItem = (e, url, ref = null, isSameTab = false) => {
  let extra = {};
  if (isSameTab) {
    if (typeof url !== "string") {
      url = addQueryParamsToLinkPostView(
        linkToPostView,
        url,
        ref,
        null,
        EnumPostRef.RECOMMENDED
      );
    }
    extra = {
      eventCallback: function () {
        window.location = url;
      },
      eventTimeout: 500,
    };
  }
  trackEventBuyer("InitPostView", `RecommendedPostCell`, false, false, extra);
};

export const gtmRecommendedAdShowMoreBtn = () => {
  trackEventBuyer("InitBrowse", `MoreBtn_Recommended`);
};

export const gtmCopyEmailClickPostView = () => {
  trackEventBuyer("EmailShow", `EmailClick_PostView`);
};

export const gtmCopyEmailPostEmailMenu = () => {
  trackEventBuyer("EmailCopy", `CopyEmailBtn_PostView`);
};

export const gtmMoreCVsBtnPostView = () => {
  trackEvent("InitLoginRegister", "LoginCVViewWidget_PostView");
};
export const gtmRequestVIN = () => {
  trackEventBuyer("RequestVIN", `RequestVINBtn_PostViewScreen`);
};
export const gtmBuyCarReport = () => {
  trackEventBuyer("BuyCarReport", `BuyCarReportBtn_PostViewScreen`);
};
export const categoryLatestAdsTitleGtm = (action, label, extraData) => {
  window.trackEventBuyerWithExtraParams(action, label, extraData);
};
export const categoryLatestMoreAdsGtm = () => {
  window.trackEventBuyerWithExtraParams("Browse", "More_LatestAds");
};

export const categoryLatestSeeAllAdsGtm = (action, label, extraData) => {
  trackEventBuyerWithExtraParams(action, label, extraData);
};
export const gtmSubCategoryLatestAds = (action, label, extraData) => {
  trackEventBuyerWithExtraParams(action, label, extraData);
};

export const gtmPromoteBtn = () => {
  trackEventSeller(
    "InitPromote",
    `PromoteBtn_PostViewScreen`,
    false,
    false,
    null,
    ENUMSELLERFLOWTYPES.Sellers
  );
};

export const gtmRepostBtn = () => {
  trackEventSeller(
    "InitRepost",
    `RepostBtn_PostViewScreen`,
    false,
    false,
    null,
    ENUMSELLERFLOWTYPES.Sellers
  );
};
